import '@lottiefiles/lottie-player';

export default defineNuxtPlugin(() => {
  // No need to do anything here because the import already registers the component globally
});
